import React, { useState } from "react";
import { apiService } from "../services/apiService";

const VideoStream = ({ isDetecting, status }) => {
  const [streamError, setStreamError] = useState(false);

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "25px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        border: "1px solid #e9ecef",
      }}
    >
      <h3
        style={{
          color: "#2c3e50",
          marginBottom: "20px",
          fontSize: "1.3rem",
          fontWeight: "500",
        }}
      >
        📹 Live Detection Feed
      </h3>

      <div style={{ textAlign: "center" }}>
        {isDetecting ? (
          <img
            src={apiService.getVideoStreamUrl()}
            alt="Detection stream"
            onError={() => setStreamError(true)}
            style={{
              maxWidth: "100%",
              border: "2px solid #ddd",
              borderRadius: "6px",
              display: streamError ? "none" : "block",
            }}
          />
        ) : null}

        {(!isDetecting || streamError) && (
          <div
            style={{
              width: "100%",
              height: "350px",
              background: "#fafafa",
              border: "2px dashed #ccc",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              color: "#999",
            }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "15px" }}>📺</div>
            <div>Video stream will appear here</div>
            <small style={{ marginTop: "8px", color: "#bbb" }}>
              Connect camera or enter stream URL
            </small>
          </div>
        )}
      </div>

      {/* Status Section */}
      <div
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "6px",
          marginTop: "25px",
          border: "1px solid #e9ecef",
        }}
      >
        <h4 style={{ marginBottom: "15px" }}>System Status</h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              marginRight: "10px",
              background: isDetecting ? "#28a745" : "#dc3545",
            }}
          ></div>
          <span>{isDetecting ? "Detection Active" : "Ready to start"}</span>
        </div>
        <div
          style={{
            marginTop: "10px",
            fontSize: "0.9rem",
            color: "#666",
          }}
        >
          <div>Frames: {status?.total_frames || 0}</div>
          <div>Detections: {status?.total_detections || 0}</div>
        </div>
      </div>
    </div>
  );
};

export default VideoStream;
